import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import '@/assets/css/style.scss';
import 'nprogress/nprogress.css';
import { createProvider } from './vue-apollo';

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  apolloProvider: createProvider(),
  created() {
    const userString = localStorage.getItem('user');
    if (userString) {
      const userData = JSON.parse(userString);
      this.$store.commit('SET_USER_DATA', userData);
    }
  },
  render: (h) => h(App),
}).$mount('#app');
